export const hy = {
  title: 'Landsat-8 / Sentinel-2 Satellite Imagery',
  content: [
    {
      label: 'Գործառույթ',
      value:
        'Բարձր լուծաչափով արբանյակային պատկերները կարևոր են GFW-ում հասանելի այլ տվյալների շերտերին համատեքստ ապահովելու համար, օրինակ՝ ծառերի ծածկույթի փոփոխության դրայվերների մեկնաբանման համար: Այն սովորաբար օգտագործվում է գրեթե իրական ժամանակում անտառահատումների մասին ահազանգերի հնարավոր պատճառները բացահայտելու համար: Պատկերները կարող են օգտագործվել նաև վավերացման արձանագրություններում՝ գնահատելու հողի/անտառային ծածկույթի ճշգրտությունը և ապրանքները փոխելու համար:',
    },
    {
      label: 'Բանաձեւ',
      value: 'Sentinal-2: 10 x 10 մետր, Landsat 8: 30 x 30 մետր',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Համաշխարհային',
    },
    {
      label: 'Աղբյուր',
      value:
        'Copernicus Sentinel-2. Վերցված է Google Earth Engine-ից։ Տվյալները մշակվել են Եվրոպական տիեզերական գործակալության (ESA) կողմից:',
    },
    {
      label: 'Հաճախականություն',
      value:
        'Ամեն օր հասանելի են դառնում նոր պատկերներ: Պատկերի վերանայման ժամանակը՝ Sentinel-2A՝ 10 օրը մեկ, Landsat 8՝ 16 օրը մեկ',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: 'Հունվար 2012 - պր.',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Այս տվյալները ցույց են տալիս արբանյակային վերջին պատկերները, որոնք համապատասխանում են Sentinel-2 և Landsat 8 համակարգերի ընտրված ամպային ծածկույթի չափանիշներին: . Sentinel-2-ը, որը շահագործվում է Եվրոպական տիեզերական գործակալության կողմից, ունի գլոբալ ծածկույթ 10 մետր լուծաչափով և կարող է թարմացված պատկերներ ստանալ 10 օրը մեկ: Landsat 8-ը, որը շահագործվում է ԱՄՆ Երկրաբանական ծառայության կողմից, նույնպես համաշխարհային արբանյակ է և կարող է ստանալ թարմացված պատկերներ՝ 30 մետր լուծաչափով, յուրաքանչյուր 16 օրը մեկ: Պատկերները, որոնք պատկերում են բնական գույնը և բուսականության առողջությունը, հասանելի են երկու արբանյակներից: Բնական գունավոր պատկերները օգտագործում են տեսանելի լույսից ստացված տեղեկատվությունը (կարմիր, կանաչ և կապույտ)՝ Երկրի մակերեսը ցույց տալու համար, ինչպես այն կթվա մարդու աչքին: Բուսականության առողջությունը հայտնաբերվում է՝ օգտագործելով նորմալացված տարբերության բուսականության ինդեքսը (NDVI), որը ներառում է տեղեկատվություն ինչպես կարմիր, այնպես էլ մոտ ինֆրակարմիր անդրադարձման վերաբերյալ: Այս մեթոդը հիմնված է այն փաստի վրա, որ առողջ բուսականությունը կլանում է տեսանելի լույսի մեծ մասը և արտացոլում է մերձ ինֆրակարմիր լույսի մեծ մասը, որը հարվածում է դրա մակերեսին: Բուսականության առողջությունը ցույց տվող պատկերները մեկնաբանելիս կարմիրը ցույց է տալիս առողջ աճող բուսականությունը, կանաչը՝ մերկ գետինը, իսկ սևը՝ ջրային մարմինները:',
  },
};
